import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

export type DatepickerSize = 'sm' | 'md' | 'lg';
export type DatepickerVariant = 'default' | 'glass';

@Component({
  selector: 'om-datepicker',
  imports: [CommonModule, ReactiveFormsModule, DatePicker],
  templateUrl: './datepicker.html',
  styleUrl: './datepicker.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Datepicker {
  /** FormControl bound to the PrimeNG DatePicker. */
  control = input.required<FormControl>();

  /** HTML id attribute for the input element. */
  inputId = input<string>('');

  /** Visual size variant. */
  size = input<DatepickerSize>('md');

  /**
   * Style variant.
   * - `default`: standard frosted-glass input with border.
   * - `glass`: transparent input, no border/bg — designed to sit inside a glass card.
   */
  variant = input<DatepickerVariant>('default');

  /** Date format for display (PrimeNG format tokens). */
  dateFormat = input<string>('dd/mm/yy');

  /** Placeholder text shown when no date is selected. */
  placeholder = input<string>('Selecciona una fecha');

  /** Emitted when the user picks a new date. */
  dateChange = output<Date | null>();

  /** CSS classes applied to the host wrapper. */
  hostClass = computed(
    () => `om-datepicker--${this.size()} om-datepicker--${this.variant()}`
  );

  /** Handles PrimeNG date selection. */
  onSelect(date: Date | null): void {
    this.dateChange.emit(date);
  }
}
